import $ from 'jQuery';

$(function () {
    $('.support-area-card__link').on('click', function () {
        let parent = $(this).parent();
        let content = $(parent).find('.support-area-card__content-bottom');
        let contentParagraphHeight = $($(content).children().get(0)).outerHeight();

        if ($(content).hasClass('active')) {
            $(this).removeClass('active');
            $(content).removeClass('active');
            $(content).css('max-height', 0);
        } else {
            $(this).addClass('active');
            $(content).addClass('active');
            $(content).css('max-height', contentParagraphHeight);
        }
    });
});
